const FIELDS = {
  house: ['city', 'street', 'block', 'building', 'floor', 'house_number', 'note', 'apartment', 'office_number'],
  apartment: ['city', 'street', 'block', 'building', 'floor', 'apartment', 'note'],
  company: ['city', 'street', 'block', 'building', 'floor', 'office_number', 'note'],
}

export default {
  namespaced: true,
  state: {
    residency: 'house',
  },
  getters: {
    areas: (state: any, getters: any, rootState: any, rootGetters: any) => {
      const user = rootGetters['auth/user']
      const zones = user.currentBranch?.zones || []

      return zones
        .filter((zone: any) => zone.visible)
        .reduce((result: any, zone: any) => [
          ...result,
          ...zone.areas.map((area: any) => ({
            ...area,
            fees: zone.fees,
            min_order: zone.min_order,
            delivery_time: zone.delivery_time,
          })),
        ], [])
    },
    config: (state: any, getters: any, rootState: any, rootGetters: any) => {
      const user = rootGetters['auth/user']
      return user.currentBranch?.kitchen_setting?.delivery_setting ?? {}
    },
    deliveryFormType: (state: any, getters: any) => getters.config.form?.type ?? 'residency',
    deliveryFields: (state: any, getters: any) => {
      if (getters.deliveryFormType === 'address') {
        return getters.config.form?.fields ?? {}
      }

      const fields = {}
      // @ts-ignore
      const residencyFields = FIELDS[state.residency]

      residencyFields.forEach((fieldKey: any) => {
        // @ts-ignore
        fields[fieldKey] = {
          on: 1,
          required: fieldKey !== 'note' && !(state.residency === 'house'),
        }
      })

      return fields
    },
    deliveryFieldsEnabled: (state: any, getters: any) => (field: any) => !!(getters.deliveryFields?.[field]?.on ?? false),
    deliveryFieldsRequired: (state: any, getters: any) => (field: any) => !!(getters.deliveryFields?.[field]?.required ?? false),
    deliveryFieldsEnabledAndRequired: (state: any, getters: any) => (field: any) => {
      const item = getters.deliveryFields[field]
      return !!(item?.required && item?.on)
    },
  },
  mutations: {
    SET_RESIDENCY(state: any, payload: any) {
      state.residency = payload
    },
  },
  actions: {
    updateResidency({ commit }: { commit: Function }, value: string) {
      commit('SET_RESIDENCY', value)
    },
  },
}
